import { createAction } from "@reduxjs/toolkit";

export const selectRoles = createAction("SET_USER_ROLES",);
